/**
 * WebHID productName 为通用 "keyboard" 且命中星闪方案时：收敛到 other 页。
 * equipmentData 上写入 OTHER_MENU_ONLY_FLAG 供菜单禁用与路由守卫读取。
 */

/** 写入 equipmentData / connectList.configuration 的标记字段名 */
export const OTHER_MENU_ONLY_FLAG = "otherMenuOnly" as const;

/** WebHID productName 是否为通用 keyboard（不区分大小写） */
export function isGenericHidKeyboardProductName(name: unknown): boolean {
  return typeof name === "string" && name.trim().toLowerCase() === "keyboard";
}

/** equipmentData 是否处于「仅 other」模式 */
export function isEquipmentOtherMenuOnly(equipment: unknown): boolean {
  if (!equipment || typeof equipment !== "object") return false;
  return Boolean((equipment as Record<string, unknown>)[OTHER_MENU_ONLY_FLAG]);
}

/**
 * 星闪 + HID productName===keyboard：在配置上打 otherMenuOnly。
 * 用于建卡与进子应用后：菜单非 other 项禁用、路由守卫强制 other。
 */
export function stampOtherMenuOnlyIfGenericXingshanHid<T extends object>(
  configuration: T | null | undefined,
  hidProductName: unknown
): T | null | undefined {
  if (!configuration || typeof configuration !== "object") return configuration;
  const sol = (configuration as { solutionRovider?: unknown }).solutionRovider;
  if (sol != null && sol !== "xingshan") return configuration;
  if (!isGenericHidKeyboardProductName(hidProductName)) return configuration;
  return {
    ...configuration,
    [OTHER_MENU_ONLY_FLAG]: true,
  };
}
